module.exports = __webpack_public_path__ + "img/filter-svgrepo-com (1) 1.1979ba85.svg";